import { __assign } from "tslib";
import React, { useEffect, useState } from 'react';
import Days from './sub-components/days/days';
import { daysInMonthEn, daysInMonthFa } from './config';
import formatDate from './shared/formatDate';
import { Div } from '@pezeshk-book/ui-kit';
import DateObject from 'react-date-object';
import persian from 'react-date-object/calendars/persian';
import persianFa from 'react-date-object/locales/persian_fa';
import createDateRange from './config/create-date-range';
var Calender = function (props) {
    var _a = props.dateFormat, dateFormat = _a === void 0 ? 'YYYY-MM-DD' : _a, _b = props.selectedDate, selectedDate = _b === void 0 ? new Date() : _b, _c = props.disablePreviousMonths, disablePreviousMonths = _c === void 0 ? false : _c, _d = props.disableSubsequentMonths, disableSubsequentMonths = _d === void 0 ? false : _d, _e = props.disablePreviousDays, disablePreviousDays = _e === void 0 ? false : _e, _f = props.disableSubsequentDays, disableSubsequentDays = _f === void 0 ? false : _f, selected = props.selected, onChange = props.onChange, _g = props.type, type = _g === void 0 ? 'jalali' : _g, holidays = props.holidays, _h = props.variant, variant = _h === void 0 ? 'simple' : _h, _j = props.size, size = _j === void 0 ? 'medium' : _j;
    var date = new DateObject({ date: selectedDate });
    var _k = useState({
        value: formatDate(selectedDate, dateFormat, type),
        cloneDays: date,
        monthName: '',
        month: '',
        year: '',
        days: []
    }), datepicker = _k[0], setDatepicker = _k[1];
    var _l = useState({
        start: null,
        end: null
    }), dateRangePicker = _l[0], setDateRangePicker = _l[1];
    var _m = useState([]), rangeDates = _m[0], setRangeDates = _m[1];
    var _o = useState(), holidayList = _o[0], setHolidayList = _o[1];
    useEffect(function () {
        var _a = type === 'gregorian' ? daysInMonthEn(datepicker.cloneDays, dateFormat) : daysInMonthFa(datepicker.cloneDays, dateFormat), monthName = _a.monthName, month = _a.month, days = _a.days, year = _a.year;
        setDatepicker(__assign(__assign({}, datepicker), { year: year, monthName: monthName, month: month, days: days, initialValue: null }));
    }, [type]);
    useEffect(function () {
        if (holidays && holidays.length) {
            var holidaysFormatList = holidays.map(function (item) { return new DateObject(item).format(dateFormat); });
            setHolidayList(holidaysFormatList);
        }
    }, [holidays, dateFormat]);
    var changeMonths = function (amount, changeType) {
        setDatepicker(function (prevState) {
            var updatedCloneDays = changeType === 'inc' ? prevState.cloneDays.add(amount, 'month') : prevState.cloneDays.setMonth(amount);
            var _a = type === 'gregorian' ? daysInMonthEn(updatedCloneDays, dateFormat) : daysInMonthFa(updatedCloneDays, dateFormat), monthName = _a.monthName, month = _a.month, days = _a.days, year = _a.year;
            return __assign(__assign({}, prevState), { year: year, monthName: monthName, month: month, days: days, cloneDays: updatedCloneDays });
        });
    };
    var changeYear = function (selectedYear) {
        setDatepicker(function (prevState) {
            var updatedCloneDays = prevState.cloneDays.setYear(parseInt(selectedYear));
            var _a = type === 'gregorian' ? daysInMonthEn(updatedCloneDays, dateFormat) : daysInMonthFa(updatedCloneDays, dateFormat), monthName = _a.monthName, month = _a.month, days = _a.days, year = _a.year;
            return __assign(__assign({}, prevState), { year: year, monthName: monthName, month: month, days: days, cloneDays: updatedCloneDays });
        });
    };
    var selectDay = function (e) {
        var faDate = e.target.dataset.jalaliDate;
        setDatepicker(__assign(__assign({}, datepicker), { value: faDate }));
    };
    var daysEventListeners = function () {
        return {
            onClick: selectDay
        };
    };
    var selectDateHandler = function (day) {
        var clickedDate = new DateObject({ date: day.gregorianDate, calendar: persian, locale: persianFa });
        var jalaliDate = new DateObject({ date: day.jalaliDate, calendar: persian }).format(dateFormat);
        var gregorianDate = new DateObject({ date: day.gregorianDate }).format(dateFormat);
        onChange({ calendarDate: clickedDate, gregorianDate: gregorianDate, jalaliDate: jalaliDate });
    };
    var selectDateRangeHandler = function (_a) {
        var start = _a.start, end = _a.end;
        setDateRangePicker({ start: start, end: end });
        var clickedStartDate = new DateObject({ date: start === null || start === void 0 ? void 0 : start.gregorianDate, calendar: persian, locale: persianFa });
        var jalaliStartDate = new DateObject({ date: start === null || start === void 0 ? void 0 : start.jalaliDate, calendar: persian }).format(dateFormat);
        var gregorianStartDate = new DateObject({ date: start === null || start === void 0 ? void 0 : start.gregorianDate }).format(dateFormat);
        var clickedEndDate = new DateObject({ date: end === null || end === void 0 ? void 0 : end.gregorianDate, calendar: persian, locale: persianFa });
        var jalaliEndDate = new DateObject({ date: end === null || end === void 0 ? void 0 : end.jalaliDate, calendar: persian }).format(dateFormat);
        var gregorianEndDate = new DateObject({ date: end === null || end === void 0 ? void 0 : end.gregorianDate }).format(dateFormat);
        onChange({
            start: start ? { calendarDate: clickedStartDate, gregorianStartDate: gregorianStartDate, jalaliStartDate: jalaliStartDate } : null,
            end: end ? { calendarDate: clickedEndDate, gregorianEndDate: gregorianEndDate, jalaliEndDate: jalaliEndDate } : null
        });
        if (start && end) {
            var range = createDateRange({ startDate: start.gregorianDate, stopDate: end.gregorianDate });
            setRangeDates(range);
        }
        else {
            setRangeDates([]);
        }
    };
    return (React.createElement(Div, { dir: 'rtl', className: 'items-center flex flex-col justify-center bg-white rounded py-4 !w-full' },
        React.createElement(Days, { days: datepicker.days, monthName: datepicker.monthName, year: datepicker.year, selectedDay: datepicker.value, disablePreviousMonths: disablePreviousMonths, disableSubsequentMonths: disableSubsequentMonths, disablePreviousDays: disablePreviousDays, disableSubsequentDays: disableSubsequentDays, daysEventListeners: daysEventListeners, selectDateHandlers: selectDateHandler, selectDateRangeHandlers: selectDateRangeHandler, selected: new DateObject({ date: selected }).format(dateFormat), date: date, increaseMonth: function () { return changeMonths(1, 'inc'); }, decreaseMonth: function () { return changeMonths(-1, 'inc'); }, changeMonth: function (monthIndex) { return changeMonths(monthIndex, 'select'); }, isDatePicker: true, dateFormat: dateFormat, type: type, holidays: holidayList, variant: variant, rangeDate: dateRangePicker, rangeDates: rangeDates, size: size, changeYear: changeYear })));
};
export default Calender;
//# sourceMappingURL=calendar.js.map